
const debug = false;
const log = (...args) => {
   if(!debug) return;
   console.log(...args);
}
class ScreenOrientationController {
	history = [];
	isTablet = () => {
		// Check user agent for iPad or Android tablets
		const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
		const isIPad = /iPad/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
		const isAndroidTablet = /Android/.test(userAgent) && !/Mobile/.test(userAgent);
		
		// Check screen dimensions (tablets typically have larger screens)
		const minDimension = Math.min(window.screen.width, window.screen.height);
		const isLargeScreen = minDimension >= 600;
		
		return isIPad || isAndroidTablet || isLargeScreen;
	};
	setDefault = () => {
		const defaultOrientation = this.isTablet() ? 'unlock' : 'portrait';
		this._updateOrientation(defaultOrientation);
	};
	restoreLastOrientation = () => {
		if (this.history.length >= 1) {
			this._updateOrientation(this.history.pop());
		}else{
			this.setDefault();
		}
	};
	onLandscapeOnlyView = () => {
		this._updateOrientation('landscape');
	};
	_updateOrientation = (orientation) => {
		log('_updateOrientation', orientation);
		if (!window.screen?.orientation?.lock) {
			return log('window.screen?.orientation?.lock not defined')
		}
		const currentOrientation = this.history.length > 0 ? this.history[this.history.length - 1] : null;
		if (currentOrientation === orientation) {
			return log('currentOrientation === orientation')
		}
		if(orientation === 'portrait' ) {
			window.screen.orientation.lock('portrait');
		} else if(orientation === 'landscape') {
			window.screen.orientation.lock('landscape');
		} else if(orientation === 'unlock') {
			window.screen.orientation.unlock();
		}
		this._settle().then().catch(console.error);
		log('orientation set ', orientation);
		this.history.push(orientation);
	};

	_settle = async () => { // may be needed to make sure the camera view is rotated
		// let iOS finish rotating + relayout
		await new Promise(r => setTimeout(r, 250));
		window.dispatchEvent(new Event("resize"));
		await new Promise(r => requestAnimationFrame(r));
		await new Promise(r => requestAnimationFrame(r));
	}
}

const screenOrientationController = new ScreenOrientationController();

export default screenOrientationController;